/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a custom domain for a tenant
 * @export
 * @interface TenantDomainCreate
 */
export interface TenantDomainCreate {
    /**
     * The full domain name
     * @type {string}
     * @memberof TenantDomainCreate
     */
    domain: string;
    /**
     * Whether this domain is for the client app (true) or main app (false)
     * @type {boolean}
     * @memberof TenantDomainCreate
     */
    isClientApp?: boolean;
}

/**
 * Check if a given object implements the TenantDomainCreate interface.
 */
export function instanceOfTenantDomainCreate(value: object): value is TenantDomainCreate {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    return true;
}

export function TenantDomainCreateFromJSON(json: any): TenantDomainCreate {
    return TenantDomainCreateFromJSONTyped(json, false);
}

export function TenantDomainCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDomainCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'isClientApp': json['is_client_app'] == null ? undefined : json['is_client_app'],
    };
}

export function TenantDomainCreateToJSON(json: any): TenantDomainCreate {
    return TenantDomainCreateToJSONTyped(json, false);
}

export function TenantDomainCreateToJSONTyped(value?: TenantDomainCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
        'is_client_app': value['isClientApp'],
    };
}

